import { TokenCollection } from './types';

export const tokens: TokenCollection = {
  '#': { pattern: /\d/ },
  X: { pattern: /[0-9a-zA-Z]/ },
  S: { pattern: /[a-zA-Z]/ },
  A: { pattern: /[0-9a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
  a: { pattern: /[0-9a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
  W: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleUpperCase() },
  w: { pattern: /[a-zA-Z]/, transform: (v) => v.toLocaleLowerCase() },
  '!': { escape: true },
};
